import { gsap } from "gsap";
export default class OverlayMenu {
  constructor(id = "main", { trigger, el, options = {} } = {}) {
    this.id = id;
    this.trigger = this.id
      ? document.querySelectorAll(
          `[data-bskr-menu-overlay-trigger="${this.id}"]`
        )
      : document.querySelectorAll(trigger);
    this.el = this.id
      ? document.querySelector(`[data-bskr-menu-overlay="${this.id}"]`)
      : document.querySelector(el);

    this.overlay = this.el.querySelector("[data-bskr-menu-overlay-bg]");
    this.wrapper = this.el.querySelector("[data-bskr-menu-overlay-wrapper]");
    this.header = this.el.querySelector("[data-bskr-menu-overlay-header]");
    this.nav = this.el.querySelector("[data-bskr-menu-overlay-nav]");
    this.gallery = this.el.querySelector("[data-bskr-menu-overlay-gallery]");
    this.footer = this.el.querySelector("[data-bskr-menu-overlay-footer]");

    this.isOpen = false;

    this.options = {
      duration: 1,
      ...options,
    };

    if (this.wrapper) {
      this.#initAnimation();
      this.#setupTimeline();

      this.init();
    }
  }

  init() {
    this.el.classList.add("bskr-overlay-menu");
    this.trigger.forEach((trigger) => {
      trigger.classList.add("bskr-overlay-menu-trigger");
      trigger.addEventListener("click", this.toggle.bind(this));
    });

    this.#animateNavLinksGallery();
  }

  toggle() {
    this.isOpen ? this.close() : this.open();
  }

  open() {
    this.isOpen = true;
    this.el.classList.add("is-open");

    this.dispatchEvent("onOpen");
    this.#animateOpenOverlay();
  }

  close() {
    this.isOpen = false;
    this.el.classList.remove("is-open");

    this.dispatchEvent("onClose");
    this.#animateCloseOverlay();
  }

  addEvent(event, callback) {
    this.trigger.forEach((trigger) => {
      trigger.addEventListener(event, callback);
    });
  }

  dispatchEvent(event) {
    this.trigger.forEach((trigger) => {
      trigger.dispatchEvent(new CustomEvent(event));
    });
  }

  destroy() {
    this.trigger.forEach((trigger) => {
      trigger.removeEventListener("click", this.toggle.bind(this));
    });
  }

  #initAnimation() {
    const itemsToApplyTweens = [this.wrapper];
    gsap.set(this.overlay, { xPercent: -100 });

    if (this.gallery) {
      const galleryItems = Array.from(this.gallery.children).filter(
        (item) => !item.hasAttribute("data-default")
      );
      itemsToApplyTweens.push(this.gallery, galleryItems);
    }

    gsap.set(itemsToApplyTweens, { opacity: 0 });
  }

  #setupTimeline() {
    this.tl = gsap.timeline({
      paused: true,
      onComplete: () => {
        this.dispatchEvent("onOpened");
      },
      onReverseComplete: () => {
        this.dispatchEvent("onClosed");
      },
    });

    this.tl.to(this.overlay, {
      xPercent: 0,
      ease: "power1.inOut",
      duration: this.options.duration,
    });

    this.tl.to([this.wrapper, this.gallery], { opacity: 1 });
  }

  #animateOpenOverlay() {
    this.tl.play();
  }

  #animateCloseOverlay() {
    this.tl.reverse();
  }

  #animateNavLinksGallery() {
    const links = this.nav.querySelectorAll("a");
    links.forEach((link) => {
      const dataPermalink = link.getAttribute("data-permalink");
      const galleryItem = this.gallery.querySelector(dataPermalink);
      if (galleryItem) {
        link.addEventListener("mouseenter", () => {
          galleryItem.classList.add("is-active");
          gsap.to(galleryItem, {
            opacity: 1,
            duration: 0.3,
          });
        });
        link.addEventListener("mouseleave", () => {
          galleryItem.classList.remove("is-active");
          gsap.to(galleryItem, {
            opacity: 0,
            duration: 0.3,
          });
        });
      }
    });
  }
}
